import { useState } from "react";
import api from "../../api/axios";
import { toast } from "react-toastify";
const AgentChatPage = ({   }) => {
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState("");
  const [loading, setLoading] = useState(false);
const agentId=`fe48fd9c-9fc5-4911-9806-367423ca1dbd`
const workspaceId=`eca5db98-571b-4735-81b4-505676753b64`
  const sendMessage = async () => {
    if (!input.trim()) return;

    const userMsg = { role: "user", content: input };
    setMessages(prev => [...prev, userMsg]);
    setLoading(true);

    try {
      const res = await api.post(
        `/agents/${agentId}/chat`,
        { message: input, workspaceId },
        { withCredentials: true }
      );

      const botMsg = {
        role: "assistant",
        content: res.data.answer
      };

      setMessages(prev => [...prev, botMsg]);
      setInput("");
    } catch (err) {

  toast.error(
    err.response?.data?.message || "Chat failed"
  );

} finally {
  setLoading(false);
}
};

  return (
    <div className="container mt-4">
      <div className="card shadow chat-card">
        <div className="card-header">
          <h5 className="mb-0">AI Agent Chat</h5>
        </div>

        <div className="card-body chat-body">
          {messages.map((msg, index) => (
            <div
              key={index}
              className={`chat-message ${
                msg.role === "user"
                  ? "user-message bg-primary text-white"
                  : "bot-message border"
              }`}
            >
              {msg.content}
            </div>
          ))}

          {loading && (
            <div className="bot-message border">
              Thinking...
            </div>
          )}
        </div>

        <div className="card-footer d-flex">
          <input
            className="form-control me-2"
            value={input}
            onChange={(e) => setInput(e.target.value)}
            placeholder="Ask something..."
          />
          <button
            className="btn btn-primary"
            onClick={sendMessage}
          >
            Send
          </button>
        </div>
      </div>
    </div>
  );
};

export default AgentChatPage;